import { AbstractCommand } from "@astina/paloma-common-ui/src/services/CommandQueue";
import vensoRepository from "@/services/VensoRepository";
import alerts from "@astina/paloma-common-ui/src/services/Alerts";
import trans from "@astina/paloma-common-ui/src/services/Translator";
export function updateDeliveryNoticeItem(groupId, accessToken, update) {
    return new UpdateDeliveryNoticeItem(groupId, accessToken, update)
        .enqueue();
}
export default class UpdateDeliveryNoticeItem extends AbstractCommand {
    groupId;
    accessToken;
    update;
    constructor(groupId, accessToken, update) {
        super();
        this.groupId = groupId;
        this.accessToken = accessToken;
        this.update = update;
    }
    async execute() {
        try {
            return await vensoRepository.updateDeliveryNoticeItem(this.groupId, this.accessToken, this.update);
        }
        catch (e) {
            alerts.error(trans(`${this.name()}.error`));
            throw e;
        }
    }
    name() {
        return 'update_delivery_notice_item';
    }
}
